"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Copyrights = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
require("./style.scss");
var Copyrights = function () { return (React.createElement("div", { className: 'copyrights animated fadeIn' },
    React.createElement("p", null,
        "\u00A9",
        (0, translation_1.getLocalization)('userfront/Login/Placeholder/CopyRightText'),
        ' ',
        React.createElement("a", { target: '_blank', href: (0, translation_1.getLocalization)('userfront/Login/Placeholder/PrivacyPolicyLink') }, (0, translation_1.getLocalization)('userfront/Login/Placeholder/PrivacyPolicy')),
        ' ',
        (0, translation_1.getLocalization)('userfront/Login/Placeholder/PrivacyPolicyAndTerms'),
        ' ',
        React.createElement("a", { target: '_blank', href: (0, translation_1.getLocalization)('userfront/Login/Placeholder/TermsOfUseLink') }, (0, translation_1.getLocalization)('userfront/Login/Placeholder/TermsOfUse'))))); };
exports.Copyrights = Copyrights;
